import { cn } from '@app/utils/cn';

interface Props {
  name: string;
  value: string;
  shouldClampText?: boolean;
  isCompact: boolean;
}

export const AttributeRow = ({ name, value, shouldClampText = false, isCompact }: Props) => {
  return (
    <div className={cn('max-w-80 break-inside-avoid-column', { 'line-clamp-2': shouldClampText })}>
      <dt className={cn('inline text-neutral-40 body-2', { 'body-5': isCompact })}>{name}: </dt>
      <dd className={cn('inline body-2', { 'body-4': isCompact })}>{value}</dd>
    </div>
  );
};
